import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

// DEPRECATED: Use `useDeviceBreakpoints` instead

export const useResponsiveBreakpoint = (breakpointKey)=> {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.only(breakpointKey), { noSsr: true });
};
